import { redirectToJiraAuth } from "../services/jiraAuthService";
import axios from "axios";
import { BASE_URL } from "../environment/environment";

export const getJiraWorklogs = async (start, end) => {
  const token = localStorage.getItem('access_token');

  try {
    const response = await axios.get(
      `${BASE_URL}/jira/Worklog?StartWorklogDate=${start}&EndWorklogDate=${end}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error sending data to backend:', error.response?.data || error.message);

    if (error.response?.status === 401) {
      console.warn('Token wygasł lub jest nieważny. Przekierowanie do ponownej autoryzacji...');
      localStorage.removeItem('access_token');
      redirectToJiraAuth();
    }

    throw new Error('Wystąpił błąd podczas pobierania danych z backendu.');
  }
};

export const getJiraAllTasks = async (start, end) => {
  const token = localStorage.getItem('access_token');

  try {
    const response = await axios.get(
      `${BASE_URL}/jira/issues?StartWorklogDate=${start}&EndWorklogDate=${end}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log(response.data)
    return response.data;
    
  } catch (error) {
    console.error('Error sending data to backend:', error.response?.data || error.message);

    if (error.response?.status === 401) {
      console.warn('Token wygasł lub jest nieważny. Przekierowanie do ponownej autoryzacji...');
      localStorage.removeItem('access_token');
      redirectToJiraAuth();
    }

    throw new Error('Wystąpił błąd podczas pobierania danych z backendu.');
  }
};







